module.exports = __webpack_public_path__ + "img/breezeway-text.fed9fde9.png";